import React,{ useEffect, useState } from "react";
import ReactDOM from 'react-dom';
import axios from 'axios';
import useSWR from 'swr'
import Spinner from "./components/Spinner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Image from "./components/Image";
import Breadcrumb from "./components/Breadcrumb";
import ContactInfo from "./components/ContactInfo";
import Swiper from "swiper";
import './../sass/style.scss';
import 'swiper/css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-regular-svg-icons";
import LastArticles from "./components/LastArticles";
import SidebarReferences from "./components/SidebarReferences";
import ContactForm from "./components/ContactForm";
import SearchBar from './components/SearchBar';
import { faFacebookF, faInstagram, faTwitter } from "@fortawesome/free-brands-svg-icons";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import AppContext from './context';
import Modal from "./components/Modal";

const url = window.location.pathname;
const fetcher = url => axios.get(url).then(res => res.data)

function Articles() {
    const { data, error } = useSWR('https://www.bwa.com.tr/api'+url, fetcher)
    const [contextData, setContextData] = useState(null);
    useEffect(() => {
        if (data) {
            new Swiper('.sidebar-refs', {
                loop:false,
                spaceBetween: 0
            });
        }
    }, [data])

    return data ? (
    <AppContext.Provider value={{ contextData, setContextData }}>
    <Header data={data.header} inPage={true} />
    <Breadcrumb background={data.page.file2} title={data.page.category_language.name}>
        <li> <a href={window.location.href}>{ data.page.category_language.name }</a> </li>
    </Breadcrumb>

    <div className="container articles">
        <div className="row">
            <div className="col-xl-8">

            <section className="article-detail">
                    {data.page?.file && (
                        <div className="article-image">
                        <span><FontAwesomeIcon icon={faCalendarAlt} /> { data.page.category_language?.extra?.date }</span>
                        <Image image={data.page.file} alt={data.page.category_language.alt?.file} />
                        </div>
                    )}
                    <h1>{data.page.category_language.description}</h1>
                    <div dangerouslySetInnerHTML={{ __html: data.page.category_language.contents }}></div>
                </section>
                <div className="articles-extra">
                    {(data.page.tags && data.page.tags.length > 0) && (
                    <div className="tags">
                        <span><i className="fas fa-tag"></i> Tag:</span>
                        {data.page.tags?.map((item,index) => {
                            return <a href={"/tags/"+item.slug} key={index}>
                            {item.name}
                        </a>
                        })}
                    </div>
                    )}
                    <div className="socials">
                        <a href={data.page.socials.facebook} target="_blank"><FontAwesomeIcon icon={faFacebookF} /></a>
                        <a href={data.page.socials.instagram} target="_blank"><FontAwesomeIcon icon={faInstagram} /></a>
                        <a href={data.page.socials.twitter} target="_blank"><FontAwesomeIcon icon={faTwitter} /></a>
                    </div>
                </div>

                {data.articles.sub_items.length > 0 && (
                <section className="blog">
                    <small className="text-start">{translations.our_articles}</small>
                    <h1 className="text-start">{translations.related_articles}</h1>
                        <div className="row">
                            {
                                data.articles.sub_items.map((item,index) => {
                                    return <div className="mb-3 col-xl-6" key={index}>
                                    <div className="item">
                                            <div className="img-container">
                                                <div className="time">
                                                    <FontAwesomeIcon icon={faCalendarAlt} /> {item.category_language?.extra?.date}
                                                </div>
                                                <Image image={item.file} alt={item.category_language.alt?.file} />
                                            </div>
                                            <div className="p-4">
                                                <h2>{item.category_language.name}</h2>
                                                <p>
                                                    {item.category_language.description}
                                                </p>
                                                <a href={item.category_language.taxonomy} className="read-more">
                                                    {translations.readmore}
                                                    <FontAwesomeIcon icon={faChevronRight} />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                })
                            }

                        </div>
                </section>
                )}

                {data.page.category_language?.extra?.hide_contact_form != 1 && (
                    <section className="contact-form">
                    <h1>{translations.contact_us}</h1>
                    <ContactForm />
                    </section>
                )}
            </div>
            <div className="col-xl-4">
                <div className="sidebar">
                    <SearchBar />
                    <LastArticles data={data.page.last_articles} title={translations.last_articles} />
                    <SidebarReferences data={data.references} />
                    <div className="contact-cards">
                        <h1>{translations.contact_info}</h1>
                        <ContactInfo data={data.contact} />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <Modal />
    <Footer data={data.footer} inPage={true} />
    </AppContext.Provider>
    ) : <Spinner />;
}

ReactDOM.render(
  <Articles />,
  document.getElementById('root')
);
